import { CabecalhoDaTela, PainelDaAba, useAbaAtual, type Aba } from "../componentes/Abas.js";
import { Link } from "react-router";
import { Icone } from "../componentes/Icone.js";
import { IconeCriar, IconeFontes, IconeImportar, IconeMarcado, IconeTrilhas } from "../componentes/icones.js";
import { Fontes } from "./Fontes.js";
import { Importar } from "./Importar.js";
import { Marcados } from "./Marcados.js";
import { Trilhas } from "./Trilhas.js";

/**
 * Acervo — trilhas, importação e fontes numa tela só (RN-30).
 *
 * As três eram destinos próprios na barra lateral, ocupando espaço permanente
 * para tarefas que se fazem uma vez por mês. Elas são o mesmo assunto — **o
 * material de estudo e de onde ele vem** — e ler uma quase sempre leva a mexer
 * na outra: importar exige trilha, e a fonte é a procedência do lote.
 *
 * **A moldura é que se nomeia.** Ela passou a ter `<h1>` próprio — "Acervo", o
 * mesmo nome que está aceso na navegação —, e cada painel deixou o dele para
 * trás. Antes era o contrário, e o resultado era tocar "Acervo" e chegar numa
 * página chamada "Trilhas": a fita de abas flutuava acima de um título que
 * dizia outra coisa, sem nada na tela ligando os dois. A frase de cada aba
 * virou a descrição dela e aparece embaixo do título enquanto ela está
 * aberta.
 */
// Importar abre primeiro: é o que se faz toda semana. Trilha se mexe pouco.
const ABAS: readonly Aba[] = [
  {
    id: "importar",
    rotulo: "Importar",
    glifo: IconeImportar,
    descricao: "Um arquivo por lote. Nada é gravado antes do relatório de validação.",
  },
  {
    id: "trilhas",
    rotulo: "Trilhas",
    glifo: IconeTrilhas,
    descricao: "Cada trilha guarda seus itens, respostas, metas e caderno. Trocar de trilha troca tudo isso.",
  },
  {
    id: "fontes",
    rotulo: "Fontes",
    glifo: IconeFontes,
    descricao: "Onde estudar cada assunto e o que ficou em aberto.",
  },
  {
    id: "marcados",
    rotulo: "Marcados",
    glifo: IconeMarcado,
    descricao: "O que você separou para voltar depois, agrupado por matéria.",
  },
];

export function Acervo() {
  const [aba, escolher] = useAbaAtual(ABAS);

  return (
    <>
      <CabecalhoDaTela
        titulo="Acervo"
        rotulo="Seções do acervo"
        abas={ABAS}
        atual={aba}
        aoEscolher={escolher}
        acoes={
          aba === "trilhas" ? (
            <Link className="botao" to="/trilhas/nova">
              <Icone glifo={IconeCriar} papel="acao" />
              Nova trilha
            </Link>
          ) : aba === "fontes" ? (
            <Link className="botao" to="/acervo?aba=fontes&nova=1">
              <Icone glifo={IconeCriar} papel="acao" />
              Nova fonte
            </Link>
          ) : undefined
        }
      />
      <PainelDaAba id={aba} className="">
        {aba === "trilhas" && <Trilhas />}
        {aba === "importar" && <Importar />}
        {aba === "fontes" && <Fontes />}
        {aba === "marcados" && <Marcados />}
      </PainelDaAba>
    </>
  );
}
